export default "__VITE_ASSET__tgFyw$X211zXSctfMU9_LA__"